export const IS_INTERSECTION_OBSERVER_SUPPORTED =
  typeof IntersectionObserver !== 'undefined' && 'IntersectionObserver' in window;
